import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SelectMenu } from '@livable/saas-react-components';
import { Button, MenuItem, Typography } from '@mui/material';
export const ModalContent = observer(_ref => {
  var _store$homeDashboardS3, _store$homeDashboardS5;
  let savedValue = _ref.savedValue,
    onSaveAndClose = _ref.onSaveAndClose,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(savedValue ? savedValue : null),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  const handleGlSearch = v => {
    var _store$homeDashboardS;
    (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.details) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.glCodeSetup) === null || _store$homeDashboardS === void 0 || _store$homeDashboardS.searchGlAccounts(v);
  };
  const handleGlSelectClose = () => {
    var _store$homeDashboardS2;
    (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.details) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.glCodeSetup) === null || _store$homeDashboardS2 === void 0 || _store$homeDashboardS2.handleGlSelectClose();
  };
  const handleChange = data => {
    setValue(data);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('GL Account')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select the utility GL account.')), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccount
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "gl-selector",
    enableSearch: true,
    labelId: "gl-selector-label",
    label: "Select utility GL account",
    disabled: ((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.details) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.glCodeSetup) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.glAccountsStored.length) === 0,
    onSearch: handleGlSearch,
    onCloseExternal: handleGlSelectClose,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => handleChange(e.target.value),
    value: value,
    renderValue: selected => {
      var _store$homeDashboardS4;
      if (selected.length === 0) {
        return '';
      }
      return (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.glCodeSetup) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.glAccountsStored.find(item => item.externalId === selected)) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.name;
    }
  }, (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.details) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.glCodeSetup) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.glAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rightButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onSaveAndClose(value);
      handleModalClose();
    },
    'custom-attribute': '639-new-billing-module'
  }, t('add_new_property_flow.save_and_close')))));
});